var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconThumb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M24.4 12.8c.5 0 1.7.4 1.6 1.9l-1.7 8.7c-.3.8-1 1.1-1.6 1.1H15c-1 0-2-.1-2.8-.5a.7.7 0 0 1-.3-.6V15l.3-.6c1.4-1 3.3-3.2 3.7-5l.3-2c0-.5.6-1 1.1-1 .7 0 1.2.7 1.4 1.6a9 9 0 0 1-.2 4.7h5.8ZM6 15.2h3V24l-.1.1H6z"
})));
export default SvgIconThumb;